import { render } from "./ProfilKemiskinan.vue?vue&type=template&id=1af3ea1a"
import script from "./ProfilKemiskinan.vue?vue&type=script&lang=js"
export * from "./ProfilKemiskinan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__